/*
 * @File state.js
 * @Description This File is for reviews state management
 */

const state = {
  reviews: {},
}

export default state
